'use client'

import { NavbarActions } from '@/components/shared/layout/navbar-actions'
import { StoryblokLink } from '@/components/shared/storyblok-link'
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from '@/components/ui/navigation-menu'
import type { GlobalNavStoryblok } from '@/lib/types/component-types-sb'
import { IconMark } from '@vendure/brand'
import Link from 'next/link'
import { Suspense, useRef } from 'react'
import { NavSubMenu } from './nav-sub-menu'

type NavbarProps = {
  content: GlobalNavStoryblok
}

export function Navbar({ content }: NavbarProps) {
  const navbarRef = useRef<HTMLHeadElement>(null)
  return (
    <header
      ref={navbarRef}
      className="bg-background border-border fixed top-0 right-0 left-0 z-50 hidden h-(--height-navbar) items-center border-b py-2 lg:flex"
    >
      <div className="container mx-auto flex items-center gap-4">
        <div className="flex grow items-center gap-6">
          <Link
            href="/"
            title="Vendure"
          >
            <IconMark className="text-brand h-8"></IconMark>
          </Link>
          <NavigationMenu delayDuration={0}>
            <NavigationMenuList>
              {content.items?.map((item) => {
                const hasSubMenu = item.cols && item.cols.length > 0

                if (hasSubMenu) {
                  return (
                    <NavigationMenuItem key={item._uid}>
                      <NavigationMenuTrigger>{item.label}</NavigationMenuTrigger>
                      <NavigationMenuContent>
                        <NavSubMenu item={item}></NavSubMenu>
                      </NavigationMenuContent>
                    </NavigationMenuItem>
                  )
                }

                return (
                  <NavigationMenuItem key={item._uid}>
                    <NavigationMenuLink
                      asChild
                      className={navigationMenuTriggerStyle()}
                    >
                      <StoryblokLink
                        link={item.target}
                        passHref
                        prefetch={true}
                      >
                        {item.label}
                      </StoryblokLink>
                    </NavigationMenuLink>
                  </NavigationMenuItem>
                )
              })}
            </NavigationMenuList>
          </NavigationMenu>
        </div>
        <Suspense>
          <NavbarActions />
        </Suspense>
      </div>
    </header>
  )
}
